import config from "../config/config";
import { getToken } from "../utils/prefix";

export async function api_getNotification(data) {
  const res = await fetch(
    config.api_backend + `/notification/getNotification`,
    {
      body: JSON.stringify(data),
      method: "POST",
      headers: {
        // Authorization: getToken(),
        "Content-type": "application/json",
      },
    }
  );

  const dataRespone = await res.json();
  return dataRespone;
}

export async function api_readNotification(data) {
  const res = await fetch(config.api_backend + `/notification/updateStatus`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      // Authorization: getToken(),
      "Content-type": "application/json",
    },
  });

  const dataRespone = await res.json();
  return dataRespone;
}

export async function api_countNotification(data) {
  const res = await fetch(config.api_backend + `/notification/count`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      // Authorization: getToken(),
      "Content-type": "application/json",
    },
  });

  const dataRespone = await res.json();
  return dataRespone;
}

export async function api_readAllNotification(data) {
  const res = await fetch(config.api_backend + `/notification/readall`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      Authorization: getToken(),
      "Content-type": "application/json",
    },
  });

  const dataRespone = await res.json();
  return dataRespone;
}
